<template>
  <div class="container">
    <div class="teachData">
      <div class="header">
        <div class="nearPrepare">
          <!-- <img class="title" src="@/assets/img/bk_w.png" alt="" srcset=""> -->
          <div class="title">{{ $t('home.nearPrepare') }}</div>
          <div class="list">
            <div class="item" v-for="item in prepareLessonList" @click="prepareLessonPreview(!item.isExample && item.id)" :key="item.id">
              <img class="cover" v-if="item.cover" :src="item.cover" alt="" srcset="">
              <img class="cover" v-else src="@/assets/img/pic_kc@2x.png" alt="" srcset="">
              <a-tooltip placement="bottom">
                <template slot="title">
                  {{ item.name }}
                </template>
                <div class="name">{{ item.name }}</div>
              </a-tooltip>
              <div class="time">{{ item.createdAt }}</div>
              <div class="shade" @click.stop="startClass(item.id)" v-if="!item.isExample && hasPermission('school_prepare_lesson')">
                <div class="button">{{ $t('home.startClass') }} ></div>
              </div>
            </div>
            <div class="item more" v-if="prepareLessonList.length < 3" @click="prepareLessonPreview()">
              <img class="cover" src="@/assets/img/pic_sx.png" alt="" srcset="">
              <div class="text">{{ $t('home.expectMore') }}</div>
            </div>
          </div>
        </div>
        <div class="nearLesson">
          <!-- <img class="title" src="@/assets/img/cz_w.png" alt="" srcset=""> -->
          <div class="title">{{ $t('home.nearLesson') }}</div>
          <div class="list">
            <div class="item" @click="createLesson(item.id)" v-for="item in createLessonList" :key="item.id">
              <img class="cover" v-if="item.cover" :src="item.cover" alt="" srcset="">
              <img class="cover" v-else src="@/assets/img/pic_cz.png" alt="" srcset="">
              <a-tooltip placement="bottom">
                <template slot="title">
                  {{ item.title || item.name }}
                </template>
                <div class="name">{{ item.title || item.name }}</div>
              </a-tooltip>
              <div class="time">{{ item.createdAt }}</div>
            </div>
            <div class="item more" v-if="createLessonList.length < 2">
              <img class="cover" src="@/assets/img/pic_cz_z.png" alt="" srcset="">
              <div class="text">{{ $t('home.expectMorePrep') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="recommended">
        <!-- <img class="title" src="@/assets/img/b_3@2x.png" alt="" srcset=""> -->
        <div class="title">{{ $t('home.recommended') }}</div>
        <div class="list">
          <div class="item" :key="item.id" v-for="item in recommendedResList">
            <img
              class="cover"
              :src="item.cover"
              @click="detail(item.id)"
              :class="item.type === 'model' ? 'model':''">
            <div class="name" @click="detail(item.id)">{{ item.name }}</div>
            <div class="desc" v-if="item.Professions.length > 0">
              <span v-for="(text, index) in item.Professions" :key="index">
                {{ index === item.Professions.length -1 ? text : text + '、' }}
              </span>
            </div>
            <div class="desc" v-else>{{ $t('home.none') }}</div>
            <span class="type" v-if="item.type !== 'other'" @click="detail(item.id)">{{ item.typeName }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="userInfo">
      <img class="avatar" :src="user.avatar ? user.avatar : require('@/assets/icons/icon_t.png')" alt="" srcset="">
      <div class="username">{{ user.name }}</div>
      <div class="schoolName">{{ teacherInfo.schoolName }}</div>
      <div class="info">
        <div>
          <div>
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t('home.myProfession') }}</span>
              </template>
              <span>{{ $t('home.myProfession') }}</span>
            </a-tooltip>
          </div>
          <div class="data profession">
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ teacherInfo.profession }}</span>
              </template>
              <span>{{ teacherInfo.profession }}</span>
            </a-tooltip>
          </div>
        </div>
        <div>
          <a-tooltip placement="bottom">
            <template slot="title">
              {{ $t('home.myClass') }}
            </template>
            <div @click="goClass">{{ $t('home.myClass') }} > </div>
          </a-tooltip>
          <a-tooltip placement="bottom">
            <template slot="title">
              {{ teacherInfo.classNum }} {{ $t('home.classCount') }}
            </template>
            <div class="data" :title="teacherInfo.classNum + $t('home.classCount')">{{ teacherInfo.classNum }} {{ $t('home.classCount') }}</div>
          </a-tooltip>
        </div>
      </div>
      <div class="title">{{ $t('home.teachingData') }}</div>
      <div class="userData">
        <div>
          <img src="@/assets/icons/icon_1.png" alt="" srcset="">
          <div>
            <div>{{ $t('home.totalCourseware') }}</div>
            <div>{{ teacherData.totalLessonNum }} <span>{{ $t('home.unit.count') }}</span></div>
          </div>
        </div>
        <div>
          <img src="@/assets/icons/icon_2.png" alt="" srcset="">
          <div>
            <div>{{ $t('home.totalTeachingDays') }}</div>
            <div>{{ teacherData.totalTeachingDays }} <span>{{ $t('home.unit.day') }}</span></div>
          </div>
        </div>
        <div>
          <img src="@/assets/icons/icon_3.png" alt="" srcset="">
          <div>
            <div>{{ $t('home.totalPrepTimes') }}</div>
            <div>{{ teacherData.totalPrepareLessonDays }} <span>{{ $t('home.unit.time') }}</span></div>
          </div>
        </div>
        <div>
          <img src="@/assets/icons/icon_4.png" alt="" srcset="">
          <div>
            <div>{{ $t('home.totalStudents') }}</div>
            <div>{{ teacherData.totalTeachingStudentNum }} <span>{{ $t('home.unit.person') }}</span></div>
          </div>
        </div>
      </div>
      <template v-if="hasPermission('teacher_course_scheduling')">
        <div class="title">{{ $t('home.trainingSchedule') }}</div>
        <div class="calendar-container">
          <ClassSchedule />
        </div>
      </template>
    </div>
    <StartClass ref="startClass"/>
  </div>
</template>
<script>
import {
  teacherInfo,
  teachingData,
  resRecommendList,
  createLessonList,
  prepareLessonList
} from '@/api/index.js'
import cookie from 'js-cookie'
import TipModal from '@/components/tipModal/index.vue'
import ClassSchedule from './classSchedule'
import StartClass from '@/views/courses/components/StartClass.vue'

export default {
  components: {
    StartClass,
    TipModal,
    ClassSchedule
  },
  data() {
    return {
      createLessonList: [
        {
          id: 1,
          name: this.$t('example.lesson.robotMaintenance'),
          createdAt: '2023-1-13 13:33',
          cover: require('@/assets/img/pic_cz.png'),
          isExample: true
        },
        {
          id: 2,
          name: this.$t('example.lesson.robotBasics'),
          createdAt: '2023-1-13 13:31',
          cover: require('@/assets/img/pic_cz.png'),
          isExample: true
        }
      ],
      prepareLessonList: [
        {
          id: 1,
          name: this.$t('example.lesson.processIntro'),
          createdAt: '2023-1-11 11:31',
          cover: require('@/assets/img/pic_bk.png'),
          isExample: true
        },
        {
          id: 2,
          name: this.$t('example.lesson.measuringTools'),
          createdAt: '2023-1-13 13:33',
          cover: require('@/assets/img/pic_bk.png'),
          isExample: true
        },
        {
          id: 3,
          name: this.$t('example.lesson.pressMachine'),
          createdAt: '2023-1-13 13:33',
          cover: require('@/assets/img/pic_bk.png'),
          isExample: true
        }
      ],
      recommendedResList: [
        {
          id: 1,
          type: 'software',
          typeName: this.$t('example.resource.type.software'),
          name: this.$t('example.resource.robotMaintenance'),
          cover: require('@/assets/img/pic_1.png'),
          Professions: [this.$t('example.profession.automation')]
        },
        {
          id: 2,
          type: 'image',
          typeName: this.$t('example.resource.type.image'),
          name: this.$t('example.resource.aircraftDesign'),
          cover: require('@/assets/img/pic_2.png'),
          Professions: [this.$t('example.profession.aviation')]
        },
        {
          id: 3,
          type: 'text',
          typeName: this.$t('example.resource.type.text'),
          name: this.$t('example.resource.robotBasics'),
          cover: require('@/assets/img/pic_3.png'),
          Professions: [this.$t('example.profession.automation')]
        },
        {
          id: 4,
          type: 'model',
          typeName: this.$t('example.resource.type.model'),
          name: this.$t('example.resource.distillationTower'),
          cover: require('@/assets/img/pic_4.png'),
          Professions: [this.$t('example.profession.chemical')]
        },
        {
          id: 5,
          type: 'video',
          typeName: this.$t('example.resource.type.video'),
          name: this.$t('example.resource.yananMuseum'),
          cover: require('@/assets/img/pic_5.png'),
          Professions: [this.$t('example.profession.tourism')]
        },
        {
          id: 6,
          type: 'audio',
          typeName: this.$t('example.resource.type.audio'),
          name: this.$t('example.resource.xibaipo'),
          cover: require('@/assets/img/pic_6.png'),
          Professions: [this.$t('example.profession.tourism')]
        },
        {
          id: 7,
          type: 'video',
          typeName: this.$t('example.resource.type.video'),
          name: this.$t('example.resource.jinggangshan'),
          cover: require('@/assets/img/pic_7.png'),
          Professions: [this.$t('example.profession.tourism')]
        },
        {
          id: 8,
          type: 'video',
          typeName: this.$t('example.resource.type.video'),
          name: this.$t('example.resource.virtualSimulation'),
          cover: require('@/assets/img/pic_8.png'),
          Professions: [this.$t('example.profession.electronic')]
        }
      ],
      teacherInfo: {
        name: this.$t('teacher.role.admin'),
        schoolName: this.$t('teacher.school.tsinghua'),
        profession: this.$t('teacher.profession.mechanical'),
        classNum: 0
      },
      teacherData: {
        classNumber: 0,
        lessonNumber: 0,
        listenNumber: 0,
        prepareLessonNumber: 0
      },
      user: cookie.getJSON('user_infor'),
      userRoles: cookie.getJSON('user_type')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.user = cookie.getJSON('user_infor')
    })
  },
  methods: {
    goLesson() {
      this.$router.push({
        name: 'lessonList'
      })
    },
    startClass(id) {
      this.$refs.startClass.selectClass(id)
    },
    goClass() {
      if (!this.hasPermission('teacher_class_management')) return this.$message.error(this.$t('message.noPermission'))
      this.$router.push({
        name: 'classList'
      })
    },
    hasPermission(tag) {
      const permissionList = localStorage.permissionList || '[]'
      return permissionList && permissionList.includes(tag)
    },
    prepareLessonPreview(id) {
      if (!this.hasPermission('school_prepare_lesson')) {
        this.$message.error(this.$t('message.noPermission'))
        return
      }
      this.$router.push({
        name: 'addCourses',
        query: {
          id
        }
      })
    },

    createLesson(id) {
      if (!this.hasPermission('school_lesson_create')) {
        this.$message.error(this.$t('message.noPermission'))
        return
      } else if (this.noCreateLesson) {
        this.$message.error(this.$t('message.noCreateLesson'))
        return
      }
      this.$router.push({
        name: 'lessonEditor',
        query: {
          id,
          type: 'editor'
        }
      })
    },
    detail(id) {
      if (this.noRecommendedRes) {
        this.$message.error(this.$t('message.noRecommendedRes'))
        return
      }
      this.$router.push({
        name: 'resourceDetail',
        query: {
          id,
          resType: 2 // type  1课程 2共享资源 3个人资源 4校级资源
        }
      })
    },
    getTeacherInfo() {
      teacherInfo().then(res => {
        this.teacherInfo = res.data
      })
    },
    getTeachingData() {
      teachingData().then(res => {
        this.teacherData = res.data
      })
    },
    getResRecommendList() {
      resRecommendList().then(res => {
        if (res.code != 200 || res.data.list.length === 0) {
          this.noRecommendedRes = true
          return
        }
        this.recommendedResList = res.data.list
      })
    },
    getCreateLessonList() {
      createLessonList().then(res => {
        if (res.code != 200 || res.data.list.length === 0) {
          this.noCreateLesson = true
          return
        }
        this.createLessonList = res.data.list
      })
    },
    getPrepareLessonList() {
      prepareLessonList().then(res => {
        if (res.code != 200 || res.data.list.length === 0) {
          this.noPrepareLesson = true
          return
        }
        this.prepareLessonList = res.data.list
      })
    },
    prevWeek() {
      this.$refs.calendar.getApi().prev()
    },
    nextWeek() {
      this.$refs.calendar.getApi().next()
    }
  },
  mounted() {
    this.getTeacherInfo()
    this.getTeachingData()
    this.getResRecommendList()
    this.getCreateLessonList()
    this.getPrepareLessonList()
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background: none !important;
  justify-content: space-between;
  .admin{
    width: 100%;
    cursor: pointer;
    text-align: right;
    margin-right: 20px;
    .user-logo{
      width: 26px;
      height: 26px;
      border-radius: 100%;
      margin-right: 12px;
    }
    .down{
      width: 10px;
      margin-left: 5px;
    }
  }
  .teachData{
    min-height: 100%;
    width: calc(100% - 317px);
    margin-right: 10px;
    .header{
      display: flex;
      margin-bottom: 18px;
      justify-content: space-between;
      .nearPrepare{
        // height: 100%;
        margin-right: 12px;
        width: calc((100% - 12px) * 0.6);
        background: url('./../../assets/img/bj_bk.png');
        background-size: 100% 100%;
        background-position: center;
      }
      .nearLesson{
        width: calc((100% - 12px) * 0.4);
        background: url('./../../assets/img/bj_cz.png');
        background-size: 100% 100%;
        background-position: center;
      }
      .nearLesson,
      .nearPrepare{
        display: flex;
        padding: 19px 25px 19px;
        flex-direction: column;
        .title{
          margin-bottom: 12px;
          color: #000000;
          line-height: 36px;
          font-family: 'ys';
          font-size: 28px;
        }
        .list{
          width: 100%;
          display: flex;
          .item{
            display: flex;
            margin-right: 20px;
            position: relative;
            border-radius: 6px;
            flex-direction: column;
            width: calc((100% - 44px) / 3);
            position: relative;
            .cover{
              width: 100%;
              max-height: 127px;
              cursor: pointer;
              margin-bottom: 10px;
              border-radius: 6px;
            }
            .name{
              width: 100%;
              color: #000;
              padding: 0 12px;
              font-size: 15px;
              cursor: pointer;
              overflow: hidden;
              font-weight: 550;
              line-height: 20px;
              text-align: center;
              margin-bottom: 6px;
              position: relative;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .time{
              font-size: 12px;
              font-weight: 400;
              color: #000000;
              line-height: 17px;
              text-align: center;
            }
            &:last-child {
              margin-right: 0;
            }
            .shade {
              top: 0;
              left: 0;
              width: 100%;
              height: calc(100% - 52px);
              display: none;
              cursor: pointer;
              border-radius: 6px;
              position: absolute;
              align-items: center;
              justify-content: center;
              background: rgba(0, 0, 0, 0.6);
              .button {
                width: 80px;
                height: 30px;
                font-size: 12px;
                font-weight: 400;
                color: #ffffff;
                line-height: 30px;
                text-align: center;
                background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
                box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
                border-radius: 6px;
              }
            }
            &:hover .shade {
              display: flex;
            }
          }
          .item.more{
            position: relative;
            .text{
              top: 45%;
              width: 100%;
              display: flex;
              font-size: 14px;
              cursor: pointer;
              color: #8994A2;
              text-align: center;
              position: absolute;
              justify-content: center;
            }
          }
        }
      }
      .nearLesson{
        .list{
          width: 100%;
          .item {
            width: calc((100% - 22px) / 2);
          }
          .item.more{
            .text{
              color: #7BA098;
            }
          }
        }
      }
    }
    .recommended{
      display: flex;
      border-radius: 8px;
      background: #FFFFFF;
      flex-direction: column;
      padding: 19px 25px 0px;
      height: calc(100% - 280px - 12px);
      // height: calc(100% - 260px);
      .title{
        margin-bottom: 12px;
        color: #000000;
        line-height: 36px;
        font-family: 'ys';
        font-size: 28px;
      }
      .list{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        overflow-y: scroll;
        padding: 0 10px;
        height: calc(100% - 40px);
        .item{
          width: calc((100% - 60px) / 4);
          display: flex;
          margin-top: 22px;
          margin-right: 20px;
          position: relative;
          border-radius: 6px;
          flex-direction: column;
          .cover{
            width: 100%;
            height: 170px;
            cursor: pointer;
            margin-bottom: 6px;
            border-radius: 6px;
          }
          .cover.model{
            background: url('./../../assets/img/bj_model.png') no-repeat;
            background-size: 100% 100%;
            background-position: center;
          }
          .type{
            left: 0;
            top: 8px;
            width: 70px;
            height: 23px;
            cursor: pointer;
            font-size: 11px;
            font-weight: 400;
            color: #28383B;
            line-height: 23px;
            text-align: center;
            position: absolute;
            border-radius: 0px 4px 4px 0px;
            background: linear-gradient(224deg, #ECEFF0 0%, #C6C9CD 100%);
          }
          .name{
            width: 100%;
            color: #000;
            font-size: 15px;
            cursor: pointer;
            overflow: hidden;
            font-weight: 550;
            line-height: 20px;
            margin-bottom: 6px;
            position: relative;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 6px 0 9px 12px;
            &::after{
              bottom: 0;
              left: 12px;
              content: '';
              width: 21px;
              height: 3px;
              opacity: 0.6;
              position: absolute;
              border-radius: 2px;
              background: #EF623D;
              box-shadow: 0px 0px 10px -2px rgba(133,133,133,0.66);
            }
          }
          .desc{
            width: 100%;
            font-size: 12px;
            cursor: pointer;
            overflow: hidden;
            font-weight: 400;
            color: #000000;
            line-height: 19px;
            padding-left: 12px;
            margin-bottom: 6px;
            position: relative;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          &:nth-child(4n) {
            margin-right: 0;
          }
          &:nth-child(-n + 4){
            margin-top: 0;
          }
        }
      }
      .list::-webkit-scrollbar{
        display: none;
      }
    }
  }
  .userInfo{
    width: 300px;
    display: flex;
    min-height: calc(100% - 20px);
    padding: 22px 17px 26px;
    align-items: center;
    flex-direction: column;
    background: url('./../../assets/img/bj_u.png');
    background-size: 100% 100%;
    background-position: center;
    .avatar{
      width: 65px;
      height: 65px;
      margin-bottom: 10px;
      border-radius: 100%;
      flex-shrink: 0;
    }
    .username{
      font-size: 14px;
      color: #000000;
      line-height: 14px;
      font-weight: bold;
      margin-bottom: 6px;
    }
    .schoolName{
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 14px;
      margin-bottom: 26px;
    }
    .info{
      width: 100%;
      display: flex;
      margin-bottom: 22px;
      justify-content: space-between;
      >div{
        width: 50%;
        display: flex;
        padding-left: 35px;
        position: relative;
        flex-direction: column;
        justify-content: center;
        >div{
          cursor: pointer;
          font-size: 12px;
          font-weight: 400;
          color: #000000;
          line-height: 17px;
          margin-bottom: 8px;
          overflow: hidden;
          white-space: nowrap;
          word-break: break-all;
          display: inline-block;
          text-overflow: ellipsis;
          &:last-child{
            font-size: 14px;
            font-weight: 400;
            color: #6A3512;
            line-height: 14px;
          }
        }
        &:first-child{
          padding-left: 0;
          padding-right: 25px;
          text-align: left;
          &::after{
            right: 0;
            width: 1px;
            content: '';
            height: 18px;
            position: absolute;
            background: url('./../../assets/img/fg_x.png');
            background-size: 100% 100%;
            background-position: center;
          }
        }
      }
      .data.profession{
        overflow: hidden;
        white-space: nowrap;
        word-break: break-all;
        display: inline-block;
        text-overflow: ellipsis;
      }
    }
    .title{
      width: 100%;
      display: flex;
      font-size: 14px;
      font-weight: 550;
      color: #000000;
      padding-left: 8px;
      position: relative;
      margin-bottom: 16px;
      align-items: center;
      &::after{
        left: 0;
        content: '';
        width: 2px;
        height: 10px;
        background: #000;
        border-radius: 5px;
        position: absolute;
      }
    }
    .userData{
      width: 100%;
      margin-bottom: 13px;
      >div{
        display: flex;
        margin-bottom: 16px;
        img{
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }
        >div{
          display: flex;
          flex-direction: column;
          justify-content: center;
          >div{
            font-size: 12px;
            font-weight: 500;
            color: #585858;
            line-height: 17px;
            &:last-child{
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              line-height: 22px;
              margin-top: 1px;
              span{
                font-size: 12px;
                font-weight: 500;
                color: #000000;
                line-height: 17px;
              }
            }
          }
        }
      }
    }
    .calendar-container {
      width: 100%;
      height: 100%;
    }
  }
}
.item:hover{
  .name{
    color: #FF6D00 !important;
  }
}
/deep/.ant-form{
  .ant-form-item{
    margin-bottom: 22px;
    .ant-form-item-label{
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
@media screen and(min-width: 1700px) and (max-width: 1900px){
  .container{
    .teachData{
      width: calc(100% - 18px - 276px);
      .header{
        .nearLesson,.nearPrepare{
          .list{
            .item{
              .cover{
                height: 112.5px;
              }
            }
          }
        }
      }
      .recommended{
        .list{
          .item{
            .cover{
              height: 155px;
            }
          }
        }
      }
    }
    .userInfo{
      width: 276px;
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px){
  .container{
    .teachData{
      width: calc(100% - 18px - 262px);
      .header{
        .nearLesson,.nearPrepare{
          .list{
            .item{
              .cover{
                height: 114px;
              }
            }
          }
        }
      }
      .recommended{
        .list{
          .item{
            .cover{
              height: 154px;
            }
          }
        }
      }
    }
    .userInfo{
      width: 262px;
    }
  }
}
@media screen and (min-width: 1400px) and (max-width: 1500px){
  .container{
    .teachData{
      width: calc(100% - 18px - 225px);
      .header{
        .nearLesson,.nearPrepare{
          .list{
            .item{
              .cover{
                height: 90px;
              }
            }
          }
        }
      }
      .recommended{
        .list{
          .item{
            .cover{
              height: 125px;
            }
          }
        }
      }
    }
    .userInfo{
      width: 225px;
    }
    .item.more .text{
      top: 40% !important;
      font-size: 12px !important;
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1400px){
  .container{
    .teachData{
      width: calc(100% - 18px - 225px);
      .header{
        .nearLesson,.nearPrepare{
          .list{
            .item{
              .cover{
                height: 80px;
              }
            }
          }
        }
      }
      .recommended{
        .list{
          .item{
            .cover{
              height: 105px;
            }
          }
        }
      }
    }
    .userInfo{
      width: 225px;
    }
    .item.more .text{
      top: 40% !important;
      font-size: 12px !important;
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px){
  .container{
    .teachData{
      width: calc(100% - 18px - 200px);
      .header{
        .nearLesson,.nearPrepare{
          .list{
            .item{
              .cover{
                height: 78px;
              }
            }
          }
        }
      }
      .recommended{
        .list{
          .item{
            .cover{
              height: 110px;
            }
          }
        }
      }
    }
    .userInfo{
      width: 200px;
    }
    .item.more .text{
      top: 40% !important;
      font-size: 12px !important;
    }
  }
}
@media screen and (max-width: 1200px){
  .container{
    .teachData{
      width: calc(100% - 18px - 160px);
      .header{
        .nearLesson,.nearPrepare{
          .list{
            .item{
              .cover{
                height: 56px;
              }
            }
          }
        }
      }
      .recommended{
        .list{
          .item{
            .cover{
              height: 80px;
            }
          }
        }
      }
    }
    .userInfo{
      width: 160px;
    }
  }
}
</style>
